import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  SvgIcon,
} from "@mui/material";
import styles from "./PracticeTestGrid.module.scss";
import Practiceexamimage1 from "./ImagePracticepage/Practice2.png";
import Practiceexamimage2 from "./ImagePracticepage/Preactice4.png";
import Practiceexamimage3 from "./ImagePracticepage/practice1.png";
import Practiceexamimage4 from "./ImagePracticepage/practice3.png";

import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listPracticeTest } from "../../Redux/Slices/PracticeTest/ListPracticeTestSlice";
import { decode } from "../../Utils/encodeDecode";
import { useNavigate } from "react-router-dom";
import { ILoginResponse } from "../Login/ILogin";
import {
  clearlistEvaluationPracticewritingExam,
  listEvaluationPracticewritingExam,
} from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import IconButtonField from "../../Components/Button/IconButtonField";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { listInstructionPracticeExamID } from "../../Redux/Slices/PracticeExam/ListinstructionPracticeExamIDSlice";
import { addStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/AddStudentExamPracticeSlice";
import { clearEditStudentExamPracticeResponse } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import Avatars from "../../Components/Avatar/Avatars";
import Menus from "../../Components/Menu/Menu";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { clearpendingPracticeExam } from "../../Redux/Slices/PendingPracticeExam/PendingPracticeExamSlice";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { ReactComponent as document_icon } from "../../Assets/Images/document_icon.svg";
import { ReactComponent as ai_star } from "../../Assets/Images/ai_star.svg";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const PracticeTestGrid = () => {
  const { data: listPracticeExams } = useAppSelector(
    (state) => state.ListPracticeTestSlice
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [details, setDetails] = useState<ILoginResponse>({});

  const images = [
    Practiceexamimage1,
    Practiceexamimage3,
    Practiceexamimage2,
    Practiceexamimage4,
  ];

  const PracticeExam = Array.isArray(listPracticeExams?.data)
    ? listPracticeExams?.data.map((user, index) => ({
      ...user,
      index: index + 1,
      image: images[index % images.length], // Assign images in a repeating pattern
    }))
    : [];

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );

  const { data: addStudentExamResult, isLoading: isAddingStudentExam } = useAppSelector(
    (state) => state.AddStudentExamPracticeSlice
  );

  const [pendingStart, setPendingStart] = useState<{ testPath: string; card: any } | null>(null);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const offsetMinutes = dayjs().tz(dayjs.tz.guess()).utcOffset();

  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listPracticeTest());
    dispatch(listUser());

    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  useEffect(() => {
    if (!isAddingStudentExam && addStudentExamResult?.status && addStudentExamResult?.data?.id && pendingStart) {
      const { testPath, card } = pendingStart;
      navigate(testPath, {
        state: {
          id: card?.id,
          name: card?.name,
          // description: card?.description,
          // instruction: card?.instruction, // compat
          student_test_id: addStudentExamResult.data.id,
        }
      });
      setPendingStart(null);
    }
  }, [addStudentExamResult, isAddingStudentExam, pendingStart, navigate]);
  function formatDuration(duration: any) {
    if (!duration) return ""; // Handle empty input gracefully

    return duration
      .replace("minutes", "min")
      .replace("minute", "min")
      .replace("hours", "hr")
      .replace("hour", "hr")
      .replace("seconds", "sec")
      .replace("second", "sec");
  }

  return (
    <div className={styles.PracticeStudentAlingment}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          {" "}
          <div className="DashboardStudent">Practice Test</div>
          <div className={styles.StudentPractice}>
            Select a test to practice your skills
          </div>
        </div>
        <div>
          <Menus
            menuItems={[
              // {
              //   menu: "Profile",
              //   onClick: () => {
              //     nav("/studentprofile");
              //   },
              // },
              {
                menu: "Logout",
                onClick: () => {
                  sessionStorage.clear();
                  dispatch(clearListuser());
                  dispatch(clearLoginStatus());
                  dispatch(clearDashboardChart());
                  navigate("/login");
                },
              },
            ]}
          >
            <IconButtonField onClick={() => { }}>
              <Avatars sx={{ height: "2rem", width: "2rem" }} />
            </IconButtonField>
          </Menus>
          <span className="Username">{ListUser[0]?.student_name}</span>
        </div>
      </div>

      <Grid container spacing={3} className="practice-test-card">
        {PracticeExam && PracticeExam?.length > 0 ? (
          PracticeExam?.map((card: any) => {
            const year_group = ListUser[0]?.year_group_data?.year_group;
            const testPath =
              year_group === "Year 12"
                ? "/ucat_practice_test"
                : "/instructionpractice";
            const resumePath =
              year_group === "Year 12"
                ? "/ucat_practice_test"
                : "/instructionpendingpractice";

            console.log("check1", year_group, testPath, resumePath, ListUser)

            return (
              <Grid item xs={12} sm={12} md={6} lg={3} key={card.id}>
                <Card className={styles.card} sx={{ boxShadow: "none" }}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      height: "175px",
                    }}
                  >
                    {/* AI badge on the left */}
                    {(card?.question_type_name === "Writing" ||
                      card?.question_type_name === "Reading Comprehension") && (
                        <div
                          style={{
                            position: "absolute",
                            top: "10px",
                            left: "10px",
                            background: "#a855f7",
                            color: "#ffff",
                            padding: "2px 7px",
                            borderRadius: "6px",
                            fontSize: "11px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "5px",
                          }}
                        >
                          {/* <AutoAwesomeOutlinedIcon />  */}
                          <SvgIcon
                            component={ai_star}
                            inheritViewBox
                            sx={{
                              fill: "none",
                              color: "#ffff",
                              fontSize: "12px",
                              marginTop: "3px",
                            }}
                          />{" "}
                          AI
                        </div>
                      )}

                    {/* Report icon on the right */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background:
                          card?.view_report !== null ? "white" : "transparent",
                        borderRadius: "5px",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <IconButtonField
                        toolTip="Report"
                        onClick={() => {
                          if (card?.question_type_name === "Writing") {
                            // dispatch(
                            //   listEvaluationPracticewritingExam({
                            //     student_test_id:
                            //       card?.view_report?.student_test_id,
                            //   })
                            // );
                            navigate("/examresultpractice", {
                              state: {
                                id: card?.view_report?.student_test_id,
                                type: "Writing",
                              },
                            });
                          } else {
                            dispatch(
                              listEvaluationPractice({
                                student_test_id:
                                  card?.view_report?.student_test_id,
                              })
                            );
                            navigate("/examresultpractice", {
                              state: {
                                id: card?.view_report?.student_test_id,
                              },
                            });
                          }
                        }}
                      >
                        {card?.view_report !== null && <AssessmentIcon />}
                      </IconButtonField>
                    </div>

                    <img
                      src={card?.image}
                      alt="Mock Exam"
                      style={{
                        width: "100%",
                        height: "90%",
                        borderRadius: "10px 10px 0px 0px",
                      }} // Adjust size as needed
                    />
                  </div>

                  <CardContent className={styles.cardBody}>
                    <div>
                      <div className={styles.mockexamname}>{card.name} </div>
                      <Typography
                        variant="body2"
                        className={styles.mockexamndescription}
                        sx={{ minHeight: "4em !important" }}
                      >
                        <p
                          style={{
                            minWidth: 0,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                            fontSize: "14px",
                            margin: "0",
                          }}
                        >
                          {card.description}
                        </p>
                      </Typography>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          // marginBottom: "8px",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            color: "#6b7280",
                            borderRadius: "20px",
                            fontSize: "15px",
                            display: "flex",
                            gap: "3px",
                            // padding: "5px",
                          }}
                          title={`Question count : ${card?.question_count}`}
                        >
                          <SvgIcon
                            component={document_icon}
                            inheritViewBox
                            sx={{
                              fill: "none",
                              fontSize: "16px",
                              marginTop: "3px",
                            }}
                          />
                          {card?.question_count | 0}{" "}
                          {card?.question_count > 1 ? "Questions" : "Question"}
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginRight: "5px",
                          }}
                        >
                          <AccessTimeIcon
                            fontSize="large"
                            sx={{
                              fontSize: "15px",
                              fontWeight: 600,
                              color: "#6b7280",
                            }}
                          />{" "}
                          <span
                            style={{
                              marginLeft: "4px",
                              fontSize: "15px",
                              color: "#6b7280",
                            }}
                          >
                            {formatDuration(card.duration)}
                          </span>
                        </span>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {card?.student_test_id === null ? (
                          <Button
                            variant="contained"
                            className={styles.startButton}
                            onClick={() => {
                              console.log("YG:::", year_group, "nav path:", testPath);
                              // dispatch(clearListPracticeExamID());
                              dispatch(
                                listInstructionPracticeExamID({
                                  test_id: card?.id,
                                })
                              );
                              dispatch(
                                addStudentExamPractice({
                                  test_id: card?.id,
                                  student_id: details?.id,
                                  closed: false,
                                  client_tz_offset: offsetMinutes,
                                })
                              );

                              setPendingStart({ testPath, card });
                              sessionStorage.setItem("ucat_exam_mode", "start");

                              sessionStorage.removeItem("pending_time");
                              sessionStorage.removeItem("remain_time");
                              sessionStorage.removeItem("response");
                              sessionStorage.removeItem("question_id");
                              sessionStorage.removeItem("question_type");
                              sessionStorage.removeItem("student_exam_id");
                              dispatch(clearEditStudentExamPracticeResponse());
                              dispatch(clearpendingPracticeExam());
                              dispatch(clearlistEvaluationPracticewritingExam());
                            }}
                            sx={{
                              borderRadius: "6px !important",
                              gap: "8px !important",
                            }}
                          >
                            <PlayArrowOutlinedIcon sx={{ fontSize: "20px" }} />
                            Start Test
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            className={styles.startButton}
                            onClick={() => {
                              console.log("YG1:::", year_group, "nav path:", resumePath);
                              sessionStorage.setItem("ucat_exam_mode", "pending");
                              navigate(resumePath, {
                                state: year_group == "Year 12" ? {
                                  student_test_id: card?.student_test_id,
                                  id: card?.id,
                                  name: card?.name,
                                  description: card?.description,
                                  instruction: card?.instruction,
                                } : {
                                  id: card?.student_test_id,
                                  name: card?.name,
                                  description: card?.description,
                                  instruction: card?.instruction,
                                }
                              });
                              sessionStorage.removeItem("pending_time");
                              sessionStorage.removeItem("remain_time");
                              sessionStorage.removeItem("response");
                              sessionStorage.removeItem("question_id");
                              sessionStorage.removeItem("question_type");
                              sessionStorage.removeItem("student_exam_id");
                            }}
                            sx={{
                              borderRadius: "6px !important",
                            }}
                          >
                            Proceed at {card?.answered_percentage}%
                          </Button>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
        ) : (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card className={styles.card} sx={{ boxShadow: "none" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={Practiceexamimage3}
                  alt="Mock Exam"
                  style={{
                    width: "100%",
                    height: "97%",
                    borderRadius: "10px 10px 0px 0px",
                  }} // Adjust size as needed
                />
              </div>

              <CardContent className={styles.cardBody}>
                <div className={styles.mockexamname}>
                  No Practice Exams Available
                </div>
                <Typography
                  variant="body2"
                  className={styles.mockexamndescription}
                >
                  Currently, there are no practice exams available at the
                  moment. Please check back soon for updates and new practice
                  exams
                </Typography>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    className={styles.startButton}
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Back to home
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default PracticeTestGrid;
